<template>
  <el-row>
    <ul class="my-info-list">
      <el-col :span="14">
        <li v-if="1 <= line && myFieldList['当前登入'] || line === 2">
          <span>当前登入</span><span>{{ account }}</span>
        </li>
        <li v-if="2 <= line && myFieldList['登入时间'] || line === 2">
           <span>登录时间</span>
          <span>
            {{lastLoginTime}}
          </span>
        </li>
        <li v-if="3 <= line && myFieldList['入场车辆']">
          <span>入场车辆</span><span>{{ info.carPassInCount || 0 }}</span>
        </li>
        <li v-if="4 <= line && myFieldList['出场车辆']">
          <span>出场车辆</span><span>{{ info.carOutCount || 0 }}</span>
        </li>
        <li v-if="5 <= line && myFieldList['场内车辆']">
          <span>场内车辆</span><span>{{ info.lotCarNum || 0 }}</span>
        </li>
        <li v-if="6 <= line && myFieldList['线上支付']">
          <span>线上支付</span
          ><span>¥{{info.chargeMessage ? info.chargeMessage.chargeOnlineTotal : 0}}元</span>
        </li>
      </el-col>
      <el-col :span="10">
        <li v-if="1 <= line && myFieldList['现金支付']">
          <span>现金支付</span
          ><span>¥{{
          info.chargeMessage ? info.chargeMessage.chargeOfflineTotal : 0
          }}元</span>
        </li>
        <li v-if="2 <= line && myFieldList['累计金额']">
          <span>累计金额</span
          ><span>¥{{
          info.chargeMessage ? info.chargeMessage.chargeTotal : 0
          }}元</span>
        </li>
        <li v-if="3 <= line && myFieldList['实收金额']">
          <span>实收金额</span
          ><span>¥{{
          info.chargeMessage ? info.chargeMessage.chargeMoneyToday : 0
          }}元</span>
        </li>
        <li v-if="4 <= line && myFieldList['异常金额']">
          <span>异常金额</span
          ><span>¥{{
          info.chargeMessage
          ? info.chargeMessage.abnormalOrderMoney
          : 0
          }}元</span>
        </li>
        <li class="li-arrears" @click="handleDialog" v-if="5 <= line && myFieldList['欠费金额']">
          <span>欠费金额</span
          ><span>¥{{
          info.chargeMessage ? info.chargeMessage.abNormalChargeMoneyToday : 0
          }}元</span>
        </li>
        <li v-if="6 <= line && myFieldList['应收金额']">
          <span>应收金额</span
          ><span>¥{{
          info.chargeMessage
          ? info.chargeMessage.chargeableAmountToday
          : 0
          }}元</span>
        </li>
      </el-col>
    </ul>
  </el-row>
</template>

<script>
import { getChargingPopUp } from "@/utils/service";
export default {
  props: {
    line: Number,
    info: Object,
    account: String,
    lastLoginTime: String,
  },
  data() {
    return {
      myFieldList: {}
    }
  },
  computed: {
    settingConfig: function () {
      return JSON.stringify(this.$store.state.layout.settingConfig) === '{}' ? JSON.parse(getChargingPopUp()) : this.$store.state.layout.settingConfig;
    },
  },
  watch: {
    settingConfig() {
      this.setFieldList();
    }
  },
  mounted() {
    // console.log(this.myFieldList, this.settingConfig)
    this.setFieldList();
  },
  methods: {
    handleDialog() {
      this.$store.dispatch("SetShowArrearsDialog", true);
    },
    setFieldList() {
      this.myFieldList = {};
      this.settingConfig.MyField && this.settingConfig.MyField.forEach(v => {
        this.myFieldList[v] = true
      });
      // console.log(this.myFieldList)
      this.$emit('popoverVisible', JSON.stringify(this.myFieldList) === '{}');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .my-info-list {
    list-style: none;
    padding: 0;
    font-size: 14px;
    & li {
      display: flex;
      line-height: 1.79;
      >span:first-of-type{
        padding-right: 5px;
        color: #909399;
      }
      span:last-of-type{
        font-weight: bold;
        .el-button--text{
          padding: 0!important;
          color: #333;
        }
      }
    }
    .li-arrears{
      cursor: pointer;
    }
    .li-arrears:hover{
      color: #3296FA;
    }
  }
</style>
